import React, { Fragment, FunctionComponent, useState, useEffect } from "react";
import OverviewPageProps from "./OverviewPageProps.interface";
import styles from "./OverviewPage.module.scss";
import ContentPageBlock from "pages/ContentPage/ContentPage.block";
import combineClasses from "helpers/combine-classes";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import Dictionary from "components/Dictionary/Dictionary";
import { BLOCK_TYPE } from "app/blocks/block.types";

const OverviewPage: FunctionComponent<OverviewPageProps> = (props) => {
    const history = useHistory();

    const [blocks, setBlocks] = useState<BLOCK_TYPE[]>([]);
    const [activeBlock, setActiveBlock] = useState("blockEventsList");
    const activeNews = activeBlock === "blockNewsList" ? styles.active : undefined;
    const activeEvents = activeBlock === "blockEventsList" ? styles.active : undefined;

    useEffect(() => {
        const query = new URLSearchParams(history.location.search);
        const block = query.get("b");

        if (typeof(block) !== "undefined" && block !== null) {
            setActiveBlock(block);
        }
        else {
            history.replace({
                pathname: location.pathname,
                search: `?b=${activeBlock}`,
                hash: location.hash
            });
        }
    }, []);

    useEffect(() => {
        const blocksResult = props.blocks && props.blocks.length > 0 ? props.blocks.filter(block => block?.content._contentType === activeBlock) : [];
        setBlocks(blocksResult);
    }, [activeBlock]);

    const onActiveBlockClick = (name: string) => {
        setActiveBlock(name);

        let query = "";
        // TODO: This is a bugfix for not showing all on init
        if (name === "blockEventsList") {
            query = `?b=${name}&f=UPCOMING`;
        }
        else {
            query = `?b=${name}`;
        }

        history.replace({
            pathname: history.location.pathname,
            search: query,
            hash: history.location.hash
        });
    };

    return (
        <Fragment>
            <div className={styles.top_overview_menu}>
                <div className={styles.inner}>
                    <div className={styles.toggle}>
                        <button onClick={() => onActiveBlockClick("blockEventsList")} className={combineClasses([styles.button, activeEvents])}>
                            <Dictionary name="OVERVIEW.EVENTS" />
                        </button>
                        <button onClick={() => onActiveBlockClick("blockNewsList")} className={combineClasses([styles.button, activeNews])}>
                            <Dictionary name="OVERVIEW.NEWS" />
                        </button>
                        <motion.div style={{ scaleY: 0.9, scaleX: 0.96 }} animate={{ x: activeEvents ? 0 : "100%" }} className={styles.button_background} />
                    </div>
                </div>
            </div>

            {/* Blocks */}
            {blocks && blocks.length > 0 && blocks.map((blockContent, index) => {
                return (
                    <ContentPageBlock key={blockContent?.contentUdi} {...blockContent} />
                );
            })}
        </Fragment>
    );
};

export default OverviewPage;